import React from 'react';
import PropTypes from 'prop-types';
import Loading from 'system/components/Loading';
import { createUseStyles } from '@glu/theming';

const useStyles = createUseStyles({
  loader: {
    zIndex: 1000
  }
});

const FallbackLoader = ({ children }) => {
  const classes = useStyles();
  return (
    <Loading
      data-qa="fallback-loader"
      isLoading
      size={35}
      className={classes.loader}
    >
      {children}
    </Loading>
  );
};

FallbackLoader.propTypes = {
  children: PropTypes.node
};

FallbackLoader.defaultProps = {
  children: <span />
};

export default FallbackLoader;
